import { SearchWriterField } from './SearchWriterField'
import { withSearchWriterField } from './withSearchWriterField'

const ConnectedSearchWriterField = withSearchWriterField(SearchWriterField)

export { ConnectedSearchWriterField as SearchWriterField }
